import { referralLink } from "@/lib/variables";

export function getCookie(name) {
  var cookieName = name + "=";
  var cookieArray = document.cookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return "";
}
export function setCookie(name, value, hours) {
  var expires = "";
  if (hours > 0) {
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + hours * 60 * 60 * 1000);
    expires = "expires=" + expirationDate.toUTCString();
  } else {
    // force cookie removal
    expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
  }
  document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

export function hasCookie(name, exactValue = null) {
  if (typeof document === "undefined") return false;

  const cookieValue = getCookie(name);

  // Cookie not present
  if (!cookieValue) return false;

  // Only presence check
  if (exactValue === null) return true;

  // Exact value match check
  return cookieValue === String(exactValue);
}

export const setLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocal = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const removeLocal = (key) => {
  localStorage.removeItem(key);
};

export function checkDevice() {
  var screenIdentity = "Desktop";
  var screenWidth = screen.availWidth;
  if (screenWidth <= 600) {
    screenIdentity = "Mobile";
  } else if (screenWidth >= 600 && screenWidth < 1024) {
    screenIdentity = "Tablet";
  } else {
    screenIdentity = "Desktop";
  }
  return screenIdentity;
}

export function notNullCheck(value) {
  return value !== null && value !== "null" && value !== undefined && value !== "undefined" && String(value).trim() !== "";
}

export function indentifyForm(identifypage) {
  const formDataMap = {
    1: { formid: "contact-form", GtagPath: "/contact-us-success" },
    2: { formid: "service-form", GtagPath: "/service-success" },
    3: { formid: "callback_formhome", GtagPath: "/callback-success" },
    4: { formid: "contact_form_popup", GtagPath: "/contact-us-popup-success" },
    5: { formid: "brochure-form", GtagPath: "/brochure-success" },
    6: { formid: "subscriptionform", GtagPath: "/newslatter-success" },
  };

  const data = formDataMap[identifypage] || formDataMap[6]; // default to newsletter

  return data; // optional — allows reuse elsewhere if needed
}

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export function CustomAlert(title, message, type = "info") {
  const alertContainer = document.getElementById("alert-container");
  if (!alertContainer) return;

  let iconPath = "/images/swal/info.png";
  let iconAlt = "Info Icon";

  switch (type) {
    case "success":
      iconPath = "/images/swal/success.png";
      iconAlt = "Success Icon";
      break;
    case "failure":
      iconPath = "/images/swal/failed.svg";
      iconAlt = "Failure Icon";
      break;
    case "warning":
      iconPath = "/images/swal/info.svg";
      iconAlt = "Warning Icon";
      break;
    default:
      icon.src = "/images/swal/info.png";
      icon.alt = "Info Icon";
      break;
  }

  const alertHTML = `
    <div class="alertparentdiv show">
      <div class="alertoverlaydiv"></div>
      <div class="alert ${type}">
        <div class="alerticondiv">
          <img class="icon" src="${iconPath}" alt="${iconAlt}">
        </div>

        <div class="text-content">
          <h3 class="popuptitle">${title}</h3>
          <p class="popupdetails">${message}</p>
        </div>

        <button class="close-btn">
          <img
            src="/images/swal/close.svg"
            alt="Close Icon"
            class="close-icon"
            loading="lazy"
          />
        </button>
      </div>
    </div>
  `;

  alertContainer.insertAdjacentHTML("beforeend", alertHTML);

  const alertParent = alertContainer.lastElementChild;
  const overlay = alertParent.querySelector(".alertoverlaydiv");
  const closeBtn = alertParent.querySelector(".close-btn");

  function removeAlert() {
    alertParent.remove();
    document.body.classList.remove("overflowhidden");
  }

  overlay.addEventListener("click", removeAlert);
  closeBtn.addEventListener("click", removeAlert);

  document.body.classList.add("overflowhidden");
}

export function handleSuccess(info) {
  CustomAlert("Thank you for reaching out and showing interest in our services", info.message, "success");
}

export function handleError(info) {
  CustomAlert(info.title, info.message, info.type);
}

export function hostfunction() {
  const inputUrl = getCookie(referralLink);

  function getHostNameFromUrl(url) {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname;
    } catch (error) {
      return url;
    }
  }

  if (notNullCheck(inputUrl)) {
    try {
      const parsedUrl = new URL(inputUrl);
      const hostName = parsedUrl.hostname;

      // ✅ New condition
      if (hostName === window.location.hostname) {
        const utmSource = parsedUrl.searchParams.get("utm_source");
        if (utmSource) {
          return utmSource; // return utm_source if available
        }
      }

      return getHostNameFromUrl(inputUrl); // fallback to host
    } catch (err) {
      return getHostNameFromUrl(inputUrl); // fallback if URL constructor fails
    }
  } else {
    return inputUrl; // cookie value is null or empty
  }
}

const PAGE_IDENTITY_MAP = Object.freeze({
  1: "homepageid",
  2: "contactuspageid",
  4: "solutionpageid",
  5: "solution2pageid",
});

export function checkPageIdentity(flag) {
  if (typeof flag !== "number") return "";

  return PAGE_IDENTITY_MAP[flag] || "";
}
